import axios from 'axios'
import Cookies from 'js-cookie'
import useSWR from 'swr'

import { API_PARAMS, PAGE_SIZE } from '../../../config/consts'

interface GetStampCampaignRankRequest {
  serviceId: string
  fromDate?: string | null // '2021-01-01'
  toDate?: string | null // '2021-01-02'
  campaignId: string | null
  limit?: number | null
  offset?: number | null
  sortTarget?: number | null
  isAsc?: boolean | null
}

interface GetStampCampaignRankResponse {
  statusCode: number
  statusMessage: string
  pushNotificationCampaignRankDatas: {
    campaignId: number
    campaignName: string
    stampCountTotal: number
    rewardCountTotal: number
    rewardRedeemCountTotal: number
    rewardRedeemRate: number
  }[]
  totalCount: number
}

const useGetStampCampaignRank = ({
  serviceId,
  fromDate,
  toDate,
  campaignId,
  limit,
  offset,
  sortTarget,
  isAsc,
}: GetStampCampaignRankRequest) => {
  const accessToken = Cookies.get('LoginToken')
  const fetcher = (url: string): Promise<GetStampCampaignRankResponse> => axios.get(url).then((res) => res.data)

  const url = new URL(`${process.env.REACT_APP_CITRUS_API_DOMAIN}/api/getStampCampaignRank`)
  // common params
  url.searchParams.append('accessToken', accessToken ?? '')
  url.searchParams.append('serviceId', serviceId)
  if (fromDate && fromDate !== '') url.searchParams.append('fromDate', fromDate)
  if (toDate && toDate !== '') url.searchParams.append('toDate', toDate)
  url.searchParams.append('campaignId', campaignId ?? API_PARAMS.SELECT_ALL)
  // sort params
  url.searchParams.append('limit', limit ? limit.toString() : PAGE_SIZE.toString())
  url.searchParams.append('offset', offset ? offset.toString() : '0')
  url.searchParams.append('sortTarget', sortTarget ? (sortTarget + 1).toString() : '0') // not 0-indexed
  url.searchParams.append('isAsc', isAsc ? 'true' : 'false')

  const { data, isLoading, mutate } = useSWR(
    () => accessToken && serviceId && fromDate && toDate && url.href,
    fetcher,
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      shouldRetryOnError: false,
    },
  )

  return {
    stampCampaignRankStoreRank: data,
    stampCampaignRankStoreRankLoading: isLoading,
    stampCampaignRankStoreRankMutate: mutate,
  }
}

export default useGetStampCampaignRank
